import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async"; // ✅ QO‘SHILDI
import i18n from "./i18n";

/* COMPONENTS */
import Header from "./components/Header";
import Footer from "./components/Footer";
import Intro from "./components/Intro";
import BackToTop from "./components/BackToTop";
import ScrollToTop from "./components/ScrollToTop";

/* PAGES */
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Gallery from "./pages/Galery";
import Tours from "./pages/Tours";
import TourDetail from "./pages/TourDetail";
import Booking from "./pages/Booking";
import Uzbekistan from "./pages/Uzbekistan";
import RegionDetail from "./pages/RegionDetail";
import Cuisine from "./pages/Cuisine";
import CuisineDetail from "./pages/CuisineDetail";
import Experience from "./pages/Experiences";
import ExperienceDetail from "./pages/ExperienceDetail";

/* =========================
   ANIMATION
========================= */
const pageVariants = {
  initial: { opacity: 0, x: 40 },
  in: { opacity: 1, x: 0 },
  out: { opacity: 0, x: -40 }
};

const pageTransition = {
  type: "tween",
  ease: "easeInOut",
  duration: 0.4
};

const motionProps = {
  initial: "initial",
  animate: "in",
  exit: "out",
  variants: pageVariants,
  transition: pageTransition
};

/* =========================
   ROUTES
========================= */
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>

        <Route path="/" element={<motion.div {...motionProps}><Home /></motion.div>} />
        <Route path="/about" element={<motion.div {...motionProps}><About /></motion.div>} />
        <Route path="/services" element={<motion.div {...motionProps}><Services /></motion.div>} />
        <Route path="/contact" element={<motion.div {...motionProps}><Contact /></motion.div>} />
        <Route path="/gallery" element={<motion.div {...motionProps}><Gallery /></motion.div>} />
        <Route path="/tours" element={<motion.div {...motionProps}><Tours /></motion.div>} />
        <Route path="/tours/:id" element={<motion.div {...motionProps}><TourDetail /></motion.div>} />
        <Route path="/tours/:id/booking" element={<motion.div {...motionProps}><Booking /></motion.div>} />
        <Route path="/uzbekistan" element={<motion.div {...motionProps}><Uzbekistan /></motion.div>} />
        <Route path="/uzbekistan/:city" element={<motion.div {...motionProps}><RegionDetail /></motion.div>} />
        <Route path="/cuisine" element={<motion.div {...motionProps}><Cuisine /></motion.div>} />
        <Route path="/cuisine/:id" element={<motion.div {...motionProps}><CuisineDetail /></motion.div>} />
        <Route path="/experiences" element={<motion.div {...motionProps}><Experience /></motion.div>} />
        <Route path="/experiences/:id" element={<motion.div {...motionProps}><ExperienceDetail /></motion.div>} />
      </Routes>
    </AnimatePresence>
  );
};

/* =========================
   APP
========================= */
export default function App() {
  const [showIntro, setShowIntro] = useState(true);

  return (
    <HelmetProvider> {/* ✅ WRAP */}
      <I18nextProvider i18n={i18n}>
        <Router>

          <ScrollToTop />
          <BackToTop />

          <div className="flex flex-col min-h-screen">

            {showIntro ? (
              <Intro onFinish={() => setShowIntro(false)} />
            ) : (
              <>
                <Header />

                <main className="flex-1">
                  <AnimatedRoutes />
                </main>

                <Footer />
              </>
            )}

          </div>
        </Router>
      </I18nextProvider>
    </HelmetProvider>
  );
}